var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('LoadingComp'),(_vm.exibir_header_footer)?_c('HeaderComp'):_vm._e(),_c('v-main',{staticClass:"background mt-2"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm.exibir_header_footer)?_c('FooterComp'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }